var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLines = function SvgLines(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "-25 0 75 75",
    id: "svg1",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 1,0 V 35 H 48 V 75",
    stroke: "url(#gradient)",
    strokeWidth: 2,
    strokeDasharray: "4, 4",
    fill: "none",
    style: {
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeWidth: 2,
      strokeDasharray: "4, 3.992",
      strokeDashoffset: 0,
      stroke: "url(#gradient)"
    },
    id: "path1"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: 25.321022,
    y1: 0,
    x2: 48,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01046867,
    stopColor: "#7171E1",
    id: "stop1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57600665,
    stopColor: "#CFCFF5",
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECFB",
    id: "stop3"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLines);
export { ForwardRef as ReactComponent };
export default "/static/media/lines.25b06e663323600678ea33103ea07e07.svg";